/**
 * Format price utility
 */

export interface FormatPriceOptions {
  locale?: string;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  /**
   * Override the currency symbol produced by Intl.NumberFormat.
   * Pass `countryConfig.currency.format` (e.g. "CA$", "AU$", "€")
   * to guarantee the correct display symbol regardless of locale.
   */
  symbolOverride?: string;
}

export function formatPrice(
  amount: number,
  options: FormatPriceOptions = {}
): string {
  const {
    locale = 'en-US',
    currency = 'USD',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    symbolOverride,
  } = options;

  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    });

    if (!symbolOverride) {
      return formatter.format(amount / 100);
    }

    // Replace the Intl-generated symbol with our explicit override
    const parts = formatter.formatToParts(amount / 100);
    return parts
      .map((part) => (part.type === 'currency' ? symbolOverride : part.value))
      .join('');
  } catch (error) {
    // Fallback for invalid currency/locale
    const symbol = symbolOverride || currency;
    return `${symbol} ${(amount / 100).toFixed(2)}`;
  }
}

